import {
  UPDATE_PENDING_REQUEST_REQUEST,
  UPDATE_PENDING_REQUEST_SUCCESS,
  UPDATE_PENDING_REQUEST_FAILURE,
} from '../../../../Constants/actionTypes';

import { updatePendingRequestApi } from '../../../../Constants/apiService';

export const updatePendingRequestRequest = () => ({ type: UPDATE_PENDING_REQUEST_REQUEST });
export const updatePendingRequestSuccess = (data) => ({ type: UPDATE_PENDING_REQUEST_SUCCESS, payload: data });
export const updatePendingRequestFailure = (error) => ({ type: UPDATE_PENDING_REQUEST_FAILURE, payload: error });

export const updatePendingRequestAct = (requestId, payload) => {
  return async (dispatch, getState) => {
    dispatch(updatePendingRequestRequest());

    const accessToken = getState()?.auth?.accessToken;

    try {
      const data = await updatePendingRequestApi(requestId, payload, accessToken);
      dispatch(updatePendingRequestSuccess(data));
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently down. Please try again later.'
          : error?.message || 'Something went wrong';

      dispatch(updatePendingRequestFailure(errorMessage));
      return null;
    }
  };
};
